import moment from 'moment';
import File from 'Classes/File';

class Folder {
  static get TYPE() {
    return 'folder';
  }

  static fromAPIResponse(res, folderID) {
    if (!res || !res.data) {
      return null;
    }
    let children = [];
    if (Array.isArray(res.data)) {
      children = res.data
        .map((c) => {
          if (!c.attributes.isFolder) {
            return File.fromJSON(c);
          }
          return Folder.fromJSON(c);
        })
        .filter(c => c !== null);
    }
    return Object.assign(new Folder(), res.data.attributes, {
      id: folderID,
      links: res.links,
      children,
    });
  }

  static fromJSON(json) {
    let { createdOn = null } = json.attributes;
    if (createdOn) {
      createdOn = moment(createdOn);
    }

    if (Array.isArray(json.children)) {
      json.children
        .map((c) => {
          if (!c.attributes.isFolder) {
            return File.fromJSON(c);
          }
          return Folder.fromJSON(c);
        })
        .filter(c => c !== null);
    }
    const folder = new Folder();
    folder.id = json.id;
    folder.attributes.isViewed = json.attributes.isViewed;
    folder.attributes.unreadCount = json.attributes.unreadCount;
    folder.attributes.fileCount = json.attributes.fileCount;
    folder.attributes.isFacetAccountStatementsFolder = json.attributes.isFacetAccountStatementsFolder;
    folder.attributes.name = json.attributes.name !== '' ? json.attributes.name : 'home';
    folder.relationships = json.relationships;
    folder.links = json.links;
    return folder;
  }

  static toAPIRequest(folder) {
    if (typeof folder !== 'object' || Number.isNaN(+folder.id)) {
      return null;
    }
    return {
      id: folder.id,
      type: Folder.TYPE,
      attributes: { ...folder, id: +folder.id },
    };
  }

  constructor() {
    this.id = '';
    this.type = 'folder';
    this.attributes = {
      status: '',
      type: '',
      createdOn: null,
      createdBy: '',
      previewURL: '',
      name: '',
      isViewed: false,
      fileCount: 0,
      isFacetAccountStatementsFolder: null,
    };
    this.children = [];
  }
}

export default Folder;
